import type {UpdateServiceCompositionFormPayload} from "./update-service-composition.schema";

import {updateServiceComposition} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../../../service-keys";

export function updateServiceCompositionMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: serviceMutationKeys.updateServiceComposition,
    mutationFn: (payload: UpdateServiceCompositionFormPayload) =>
      updateServiceComposition(id, payload),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: serviceKeys.detail(id)}),
        client.invalidateQueries({queryKey: serviceKeys.lists()}),
      ]);
    },
  });
}
